import { render, staticRenderFns } from "./ModelsContainer.vue?vue&type=template&id=50136627&scoped=true&"
import script from "./ModelsContainer.vue?vue&type=script&lang=js&"
export * from "./ModelsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModelsContainer.vue?vue&type=style&index=0&id=50136627&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50136627",
  null
  
)

export default component.exports